import Tracker from "@openreplay/tracker"

let tracker: Tracker | null = null

export const getTracker = (): Tracker => {
  const openReplayKey: string  = process.env.NEXT_PUBLIC_OPENREPLAY_KEY || ""
  if (!tracker) {
    tracker = new Tracker({
      projectKey: openReplayKey,
      // __DISABLE_SECURE_MODE: true, // Disable secure mode for localhost
    })
  }
  return tracker
}
